import React, { useId } from "react";
import { Button, Modal } from "react-bootstrap";
import SubmitButton from "./SubmitButton";

const ConfirmationDialog = ({
  title,
  message,
  errorMessage,
  showModal,
  isConfirming,
  handleConfirm,
  handleClose,
  confirmLabel = "Retire",
  confirmVariant = "danger",
}: {
  title: string;
  message: React.ReactNode;
  errorMessage?: React.ReactNode;
  showModal: boolean;
  isConfirming: boolean;
  handleConfirm: () => void;
  handleClose: () => void;
  confirmLabel?: string;
  confirmVariant?: "primary" | "secondary" | "danger";
}) => {
  const titleId = useId();
  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      centered
      aria-labelledby={titleId}
    >
      <Modal.Header>
        <Modal.Title id={titleId}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {errorMessage}
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={handleClose}
          disabled={isConfirming}
        >
          Cancel
        </Button>
        <SubmitButton
          variant={confirmVariant}
          label={confirmLabel}
          onClick={handleConfirm}
          isSubmitting={isConfirming}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationDialog;
